import { ComponentSettings } from "../settings/settings";

const settings = {
  permission: {
    view: false,
  },
  text: {
    title: {
      de: "Daten exportieren",
      en: "Export Data",
      nl: "Gegevens exporteren",
    },
    parts: { de: "Teile", en: "Parts", nl: "Artikelen" },
    maunfacturers: {
      de: "Hersteller",
      en: "Manufacturers",
      nl: "Fabrikanten",
    },
    messages: { de: "Meldungen", en: "Messages", nl: "Berichten" },
    alerts: {
      de: "Alarme",
      en: "Alerts",
      nl: "RM Alerts",
    },
    description: {
      de: "Wählen Sie die Dokumenttypen für den Export im JSON-Format aus",
      en: "Select document types to export in JSON format",
      nl: "Selecteer documenttypes om te exporteren in JSON-indeling",
    },
    export: { de: "Exportieren", en: "Export", nl: "Export" },
  },
  list: {},
  url: {},
  field: {},
  additionalInfo: {},
};

export const exportData: ComponentSettings<typeof settings> = settings;
